const req_wideshot = {
  1: 2000,
  2: 4000,
}
const req_rapidfire = {
  1: 2000,
}
const req_bullet = {
  1: 2000,
  2: 9000,
  3: 10000,
}
const req_heal = {
  1: 2000,
  2: 6000,
  3: 9000,
}

export { req_wideshot, req_rapidfire, req_bullet, req_heal }
